import React, { useEffect } from 'react';

import { AddCircleOutline, AddOutlined, Close, EditOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from 'redux/slices/uiSlice';
import { CustomButton, TableData } from 'components';
import { validatePermission } from 'helpers/authentication';
import { errorAlert } from 'helpers/alerts';
import { getCarriersListService } from 'services/admin/providerService';
import { setCarrierList, setCurrentCarrier } from 'redux/slices/admin/providerSlice';
import { useNavigate } from 'react-router-dom';

function CarriersScreen() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { carrierList } = useSelector(store => store.providers)

    useEffect(() => {
        dispatch(setTitle('Carriers'));
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        (async () => {
            try {
                const response = await getCarriersListService();
                dispatch(setCarrierList(response));
            } catch (error) {
                errorAlert(error);
            }
        })();
    }, []);

    return (
        <TableData
            dataRows={carrierList}
            headerButtons={[
                validatePermission('proveedores', 'proveedores', ['agregar']) &&
                <CustomButton
                    icon={<AddOutlined />}
                    key="addCarriers"
                    name={"Nuevo carrier"}
                    click={() => navigate("create")}
                />,
            ]}
            dataTitle={[
                "Nombre",
                "Carrier Id"
            ]}
            formatter={({ name, carrier_id }) => ([
                name,
                carrier_id
            ])}
            actions={[
                {
                    label: "Editar",
                    icon: <EditOutlined />,
                    onClick: (data) => {
                        dispatch(setCurrentCarrier(data));
                        navigate("edit");
                    },
                },
            ]}
        />
    );
}

export default CarriersScreen;